import { useTranslation } from 'react-i18next';

import { InfoBox, SectionTitle } from '@basic';
import { GoalModel } from 'lib/models/goals';

export default function GoalSampleTasks({ goal }: { goal: GoalModel }) {
  const { t } = useTranslation();
  return (
    <InfoBox>
      <SectionTitle text={t('components.goalSampleTasks.title')} />
    </InfoBox>
  );
}
